<ng-container *ngIf="!loaded">
  <div class="loader-wrapper centered">
    <div class="loader-container">
      <app-loader></app-loader>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="loaded">
  <div class="mt-3">
    <div class="row">
      <div class="col-12">
        <h1 class="mb-0">{{ "SUBAGENCY_LIST.TITLE" | translate }}</h1>
      </div>
      <div class="col-12">
        <button
          class="btn btn-primary rounded float-right"
          [title]="'SUBAGENCY_LIST.ADD_SUBAGENCY_TOOLTIP' | translate"
          (click)="addNewSubagency(addNewSubagencyModal)"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="mt-4" *ngIf="agencies.length">
      <div class="table-responsive">
        <table class="table table-default table-hover mb-0">
          <thead>
            <tr>
              <th scope="col">
                {{ "SUBAGENCY_LIST.TABLE.SUBAGENCY" | translate }}
              </th>
              <th scope="col">
                {{ "SUBAGENCY_LIST.TABLE.MANAGERS" | translate }}
              </th>
              <th scope="col">
                {{ "SUBAGENCY_LIST.TABLE.AGENTS" | translate }}
              </th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let agency of agencies"
              (click)="view(agency.id)"
              class="cursor-pointer"
            >
              <td>{{ agency.name }}</td>
              <td>{{ getNumberOfRoles(agency, "manager") }}</td>
              <td>{{ getNumberOfRoles(agency, "agent") }}</td>
              <td>
                <div
                  class="d-flex align-items-center justify-content-end gap-10"
                >
                  <i
                    class="material-symbols-outlined remove-icon"
                    [title]="'SUBAGENCY_LIST.TABLE.REMOVE_TOOLTIP' | translate"
                    (click)="
                      $event.stopPropagation(); deactivateAgency(agency.id)
                    "
                  >
                    delete
                  </i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" *ngIf="!agencies.length">
      <div class="col">
        {{ "SUBAGENCY_LIST.NO_SUBAGENCIES" | translate }}
      </div>
    </div>
  </div>
</ng-container>
<ng-template #addNewSubagencyModal let-c="close" let-d="dismiss">
  <div class="modal-card card">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="card-header-title">
            {{ "SUBAGENCY_LIST.NEW_SUBAGENCY_MODAL.TITLE" | translate }}
          </h3>
        </div>
        <div class="col-auto">
          <i
            data-dismiss="modal"
            aria-hidden="true"
            (click)="d('closed')"
            class="material-icons float-right close-icon"
          >
            close
          </i>
        </div>
      </div>
    </div>
    <div class="card-body row">
      <div class="form-group form-group-sm col-lg-12">
        <label class="font-weight-bold">{{
          "SUBAGENCY_LIST.NEW_SUBAGENCY_MODAL.AGENCY_NAME.LABEL" | translate
        }}</label>
        <input
          [ngStyle]="{ 'border-color': errors.agency ? '#dc3545' : null }"
          [(ngModel)]="model.name"
          class="form-control"
          type="text"
          [placeholder]="
            'SUBAGENCY_LIST.NEW_SUBAGENCY_MODAL.MANAGER_EMAIL.PLACEHOLDER'
              | translate
          "
          required
        />
        <div class="errors" [hidden]="!errors.agency">
          {{ errors.agency | capitalizeFirstLetter }}
        </div>
      </div>
      <div class="form-group form-group-sm col-lg-12">
        <label class="font-weight-bold">{{
          "SUBAGENCY_LIST.NEW_SUBAGENCY_MODAL.MANAGER_EMAIL.LABEL" | translate
        }}</label>
        <input
          [ngStyle]="{ 'border-color': errors.email ? '#dc3545' : null }"
          [(ngModel)]="model.email"
          class="form-control"
          type="text"
          [placeholder]="
            'SUBAGENCY_LIST.NEW_SUBAGENCY_MODAL.MANAGER_EMAIL.PLACEHOLDER'
              | translate
          "
          required
        />
        <div class="errors" [hidden]="!errors.email">
          {{ errors.email | capitalizeFirstLetter }}
        </div>
      </div>
      <div class="col-lg-12">
        <div
          *ngIf="errors.error?.summary"
          class="alert-danger-provider p-3 mb-3 rounded"
        >
          {{ errors.error.summary }}
        </div>
        <error-alert-block [error]="agencyError"> </error-alert-block>
      </div>
    </div>
    <div class="card-footer text-right">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        (click)="d('closed')"
      >
        {{ "BUTTONS.CANCEL" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="save(c)"
        [disabled]="!(model.email && model.name)"
      >
        {{ "BUTTONS.ADD" | translate }}
      </button>
    </div>
  </div>
</ng-template>
